import $ from './src/jquery-core.js';

export default $;
